import { Injectable } from '@angular/core';
import { ViewColumnState } from '../../../application-controller/store/states/view-col.states';
import { UtilBranchSettingsListingComponent } from '../branch-settings-container/branch-settings-listing/branch-settings-listing.component';
import { UtilBranchEditComponent } from '../branch-settings-container/branch-edit/branch-edit.component';
import { ViewColumn } from '../../../view-column';
import { UtilBranchPricingSchemeCreateComponent } from '../branch-settings-container/pricing-scheme/create/create.component';
import { UtilBranchPricingSchemeEditComponent } from '../branch-settings-container/pricing-scheme/edit/edit.component';
import { BranchPrintableAddComponent } from '../branch-settings-container/printable-format/add/add.component';
import { BranchPrintableEditComponent } from '../branch-settings-container/printable-format/edit/edit.component';
import { BranchPrintableImageLinkAddComponent } from '../branch-settings-container/printable-format/edit/image/add/add.component';
import { BranchPrintableImageLinkEditComponent } from '../branch-settings-container/printable-format/edit/image/edit/edit.component';
import { BranchPrintableImageAddComponent } from '../branch-settings-container/printable-image/add/add.component';
import { BranchPrintableImageEditComponent } from '../branch-settings-container/printable-image/edit/edit.component';
import { BranchEmployeeLinkAddComponent } from '../branch-settings-container/employee/add/add.component';
import { BranchEmployeeLinkEditComponent } from '../branch-settings-container/employee/edit/edit.component';

@Injectable()

export class BranchSettingsPagesService {

  private initialState: ViewColumnState = {
    firstColumn: new ViewColumn(0, UtilBranchSettingsListingComponent, 'Branch Listing', {
      deactivateAdd: false,
      deactivateList: false,
    }),
    secondColumn: null,
    viewCol: [
      new ViewColumn(0, UtilBranchSettingsListingComponent, 'Branch Listing', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(1, UtilBranchEditComponent, 'Branch Edit', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(2, UtilBranchPricingSchemeCreateComponent, 'UtilBranchPricingSchemeCreateComponent', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(3, UtilBranchPricingSchemeEditComponent, 'UtilBranchPricingSchemeEditComponent', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(4, BranchPrintableAddComponent, 'BranchPrintableAddComponent', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(5, BranchPrintableEditComponent, 'BranchPrintableEditComponent', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(6, BranchPrintableImageLinkAddComponent, 'BranchPrintableImageLinkAddComponent', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(7, BranchPrintableImageLinkEditComponent, 'BranchPrintableImageLinkEditComponent', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(8, BranchPrintableImageAddComponent, 'BranchPrintableImageAddComponent', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(9, BranchPrintableImageEditComponent, 'BranchPrintableImageEditComponent', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(10, BranchEmployeeLinkAddComponent, 'BranchEmployeeLinkAddComponent', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(11, BranchEmployeeLinkEditComponent, 'BranchEmployeeLinkEditComponent', {
        deactivateAdd: false,
        deactivateList: false
      }),
    ],
    breadCrumbs: [],
    leftDrawer: [],
    rightDrawer: [],
    singleColumn: false,
    prevIndex: null
  };

  get pages() {
    return this.initialState;
  }

  constructor() { }
}
